import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NbAlertModule } from '@nebular/theme';
import {
  NbAuthComponent,
  NbLogoutComponent,
} from '@nebular/auth';
import { AuthGuard } from './_helpers/auth.guard';
import { LoginComponent } from './pages/auth/login/login.component';
import { RegisterComponent } from './pages/auth/register/register.component';
import { ResetPswComponent } from './pages/auth/reset-psw/reset-psw.component';
import { ChangePswComponent } from './pages/auth/change-psw/change-psw.component';
import { WelcomeComponent } from './pages/auth/welcome/welcome.component';
import { EmailValidationComponent } from './pages/email-validation/email-validation.component';
import { PasswordResetValidationComponent } from './pages/password-reset-validation/password-reset-validation.component';

export const routes: Routes = [
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'api',
    component: RegisterComponent,
    children: [
      {
        path:'',component:RegisterComponent,
      }
    ]
  },

  {
    path: 'auth',
    component: NbAuthComponent,
    children: [

    {
  path: 'passwordreset',
  component: PasswordResetValidationComponent,
    },
      {
        path: 'emailvalidation',
        component: EmailValidationComponent,
      },

      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'register',
        component: RegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      // Cambio Password
      {
        path: 'change-password',
        component: ChangePswComponent,
        canActivate: [AuthGuard],
        data: { "edit": "user" },
      },
      // Reset Passoword
      {
        path: 'reset-password',
        component: ResetPswComponent,
      },

    ],
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },

];

const config: ExtraOptions = {
  useHash: false,
  onSameUrlNavigation: 'reload',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config), NbAlertModule],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
